import React,{useEffect,useState} from 'react'
import { useAuthContext } from '../../context/Auth/Create'
import { assetUrl } from '../../helpers';
import { Attendance } from '../../sdk'
import { Loader } from '../Default';
import { useParams } from 'react-router-dom';

// import boopSfx from "assert/audio/notification.wav";

export function AttendancePageWithCameraWise() {
  const paramData = useParams();
 
  const [state,setState]=useState({cameraId:paramData.cameraId,loader:true,data:[]});
  const userAuth=useAuthContext();
  const apiData=async()=>{
  try{
    
    let result=await new Attendance().getAttendanceCameraWise({camera_id:state.cameraId});
    setState((pre)=>{
      return {...pre,data:result,loader:false};
    })
}catch(e){
console.log(e);
}
  }
  function socketHandle (){
    apiData()
    
   
  }


   useEffect(()=>{
    
    apiData()
   userAuth.socket.on("getAttendance",socketHandle)
  
   const timer=setInterval(()=>{
    apiData();
   },1000 *10)
   return ()=>{
    userAuth.socket.off("getAttendance",socketHandle)
   clearInterval(timer)
   }
   },[paramData])
   if(state.loader)  return <Loader/>;
  return (
    <div id="app" className="app">
  
    <div className="container">
           <div className="row justify-content-center">
      
        <div className="col-xl-12">
          {/* BEGIN row */}
          <div className="row">
            {/* BEGIN col-9 */}
            <div className="col-xl-12">
              <div id="hoverableRows" className="mb-5">
                <h4>Attendance</h4>
               
                <div className="card">
                  <div className="card-body">
                    <table className="table table-hover table-bordered mb-0" style={{textAlign:"center"}}>
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">ID</th>
                          <th scope="col">Time</th>
                          <th scope="col">Image</th>
                          {/* <th scope="col">Entrance 2</th> */}
                         
                        </tr>
                      </thead>
                      <tbody>
                      {state.data.map((val)=>{
                       
                      
                      
                        
                        return (<>
                        
                         <tr>
                         <th scope="col" style={{maxWidth:"5px"}}>{val.employeeName}</th>
                         <th scope="col" style={{maxWidth:"5px"}}>{val.employeeId}</th>
                         <th scope="col" style={{maxWidth:"5px"}}>{val.checkIn?val.checkIn:val.checkOut}</th>
                          <th scope="col" style={{maxWidth:"5px"}}><img src={`${assetUrl}${val.imageName}`} style={{width:"250px",height:"250px"}}/></th>
                         
                         
                        </tr>
                        </>)
                       })}
                      
                      </tbody>
                    </table>
                  </div>
                  <div className="card-arrow">
                    <div className="card-arrow-top-left" />
                    <div className="card-arrow-top-right" />
                    <div className="card-arrow-bottom-left" />
                    <div className="card-arrow-bottom-right" />
                  </div>
               
                </div>
              </div>
            </div>
            {/* END row */}
          </div>
          {/* END col-10 */}
        </div>
        {/* END row */}
      </div>
      {/* END container */}
    </div>
  </div>
  

  )
}